<script lang="ts">
	//Formatting
	import { format } from 'svelte-i18n';
	//Design system components
	import {
		ControlsContainer,
		FlexibleCard,
		Icon,
		LinearGauge,
		PlainTable,
		StatusIndicator,
		SystemStyles,
		Text,
	} from '@Shelly/shelly-design-system/index';
	//Helpers
	import {
		buildEvTemplate,
		getStatusIndicatorState,
	} from 'src/helpers/virtual_helpers/template_helpers/virtual_ev_template_helpers';
	//Components
	import VirtualBooleanButton from '../Components/VirtualBooleanButton.svelte';
	import TemplateToggle from './components/TemplateToggle.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let device: Device;
	export let statuses: VCInterfaceStatus[];

	$: evData = buildEvTemplate(statuses);
</script>

<div class="flex-full-height">
	{#if evData.work_state}
		<div class="d-flex justify-content-center mb-m mt-s">
			<StatusIndicator
				title={evData.work_state.value}
				state={getStatusIndicatorState(evData.work_state.event)}
				subtitle={$format('label_current_state', { default: 'Current state' })}
			/>
		</div>
	{/if}
	<div class="flex-full-height justify-content-end">
		{#if evData.current}
			<FlexibleCard
				backgroundColor={$showNewLayout ? '--color-0' : undefined}
				class="mb-s"
				padding="m"
				mainContentPrioritySlot="both"
				header={$format('em_current', { default: 'current' })}
				icon="fas fa-bolt"
			>
				<LinearGauge
					class="mt-s"
					type="incremented"
					incrementedValue={{
						value: evData.current?.rawValue ?? 0,
						color: SystemStyles.COLOR_ELECTRIC_VEHICLE,
						labelProps: {
							icon: 'fas fa-car',
							value: evData.current?.value || '',
							iconColor: SystemStyles.COLOR_ELECTRIC_VEHICLE,
						},
					}}
					unit={evData.max_charge?.unit || 'A'}
					minValue={0}
					maxValue={evData.max_charge?.rawValue ?? 40}
				/>
			</FlexibleCard>
		{/if}
		<FlexibleCard
			backgroundColor={$showNewLayout ? '--color-0' : undefined}
			class="mb-s"
			padding="m"
			mainContentPrioritySlot="both"
			header={$format('power', { default: 'power' })}
			icon="fas fa-transformer-bolt"
		>
			<PlainTable class="width-full">
				<colgroup>
					<col class="col-label" />
					<col class="col-value" />
				</colgroup>
				<tbody>
					{#each evData.statusInfo as statusInfo}
						<tr>
							<th
								><Icon
									class="mr-s"
									icon={statusInfo.icon}
									size="xs"
								/>{statusInfo.title}</th
							>
							{#if statusInfo.role === 'auto_balancing'}
								<td
									style="margin-right:-8px"
									class="d-flex align-items-center justify-content-end"
								>
									<TemplateToggle {device} status={statusInfo.status} />
								</td>
							{:else}
								<td>{statusInfo.value}</td>
							{/if}
						</tr>
					{/each}
				</tbody>
			</PlainTable>
		</FlexibleCard>
		{#if evData.auto_start}
			<ControlsContainer color={$showNewLayout ? 'color-0' : undefined}>
				<svelte:fragment slot="first">
					<VirtualBooleanButton
						{device}
						componentID={evData.auto_start.id}
						value={evData.auto_start.event}
						isWide
					/>
					<Text styleType="controls-large" class="mt-s text-bold"
						>{$format('vc_template_auto_start', { default: 'Auto start' })}</Text
					></svelte:fragment
				>
			</ControlsContainer>
		{/if}
	</div>
</div>

<style>
	.col-label {
		width: 70%;
	}
	.col-value {
		width: 30%;
	}
</style>
